import { useState } from "react";
import { adminApi, formatApiError } from "@/lib/adminApi";
import { BrandBand } from "@/components/vendor/Brand";
import { PasswordInput } from "@/components/admin/PasswordInput";
import { ForgotPassword } from "@/components/admin/ForgotPassword";

export const AdminLogin = ({ onLogin }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await adminApi.post("/admin/login", { password });
      onLogin(data.token);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail, "Could not sign in"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hx" data-testid="admin-login-page">
      <BrandBand />
      <form className="hx-container hx-login hx-fade" onSubmit={submit}>
        <h1>Studio admin</h1>
        <p className="hx-muted" style={{ marginBottom: 24 }}>Enter the admin password to continue.</p>
        <label className="hx-field" htmlFor="admin-password">
          <span className="hx-label">Password</span>
          <PasswordInput id="admin-password" value={password} onChange={setPassword} autoFocus autoComplete="current-password" testId="admin-password-input" />
        </label>
        {error && <p className="hx-alert" style={{ marginTop: 14 }} data-testid="admin-login-error">{error}</p>}
        <button className="hx-btn" style={{ marginTop: 20, width: "100%" }} disabled={loading || !password} data-testid="admin-login-button">
          {loading ? "Signing in…" : "Sign in"}
        </button>
        <ForgotPassword />
      </form>
    </div>
  );
};
